import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ICategory, DoodProductModel } from '@core/models/product.model';
import { CategoryKeys } from '@config/keys/category.keys';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { ColorFieldTypesValues } from '@config/values/color-field-types.values';
import { ContentBuilderFieldColors } from '@shared/interfaces/content-builder.interface';

@Component({
  selector: 'app-product-category-cards-with-name-atom',
  templateUrl: './product-category-cards-with-name-atom.component.html',
})
export class ProductCategoryCardsWithNameAtomComponent {
  @Input() displayContext = '';
  @Input() category!: ICategory;
  @Input() products!: DoodProductModel[];
  @Input() isOrderingAllowed = true;
  @Input() categoryNameColor: IContentBuilderFieldColor = {
    value: 'neutral-900',
    type: ColorFieldTypesValues.Hex,
  };
  @Input() categoryDescriptionColor: IContentBuilderFieldColor = {
    value: 'neutral-600',
    type: ColorFieldTypesValues.Hex,
  };
  @Input() productNameColor: IContentBuilderFieldColor = {
    value: 'neutral-900',
    type: ColorFieldTypesValues.Hex,
  };
  @Input() productDescriptionColor: IContentBuilderFieldColor = {
    value: 'neutral-900',
    type: ColorFieldTypesValues.Hex,
  };
  @Input() productPriceColor: IContentBuilderFieldColor = {
    value: 'neutral-900',
    type: ColorFieldTypesValues.Hex,
  };
  @Input() productImagePlaceholderColor: IContentBuilderFieldColor = {
    value: 'neutral-50',
    type: ColorFieldTypesValues.Hex,
  };
  @Input() productBorderColor: IContentBuilderFieldColor = {
    value: 'neutral-100',
    type: ColorFieldTypesValues.Hex,
  };
  @Input() productBackgroundColor: IContentBuilderFieldColor = {
    value: 'transparent',
    type: ColorFieldTypesValues.Hex,
  };
  @Input({ required: true }) tagColors!: ContentBuilderFieldColors;
  @Output() navigateTo = new EventEmitter<DoodProductModel>();

  categoryKeys = CategoryKeys;

  onNavigateTo(product: DoodProductModel): void {
    this.navigateTo.emit(product);
  }
}
